<div class="d-flex justify-content-start align-items-center pb-3">
    <h6>
        Selezionare l'IBAN per la liquidazione:
    </h6>
</div>
<ng-container *ngIf="ibanList">
    <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
</ng-container>
